import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

import locale from "locale";
import api from "api";
import routes from "config/routes";
import useFormState from "../Form/useFormState";
import useNavStore from "stores/useNavStore";
import Form from "../Form";

export default () => {
  /**
   * Hooks
   */
  const { name, description, isActive, setForm } = useFormState();
  const navigate = useNavStore((state) => state.navigate);

  const queryClient = useQueryClient();

  const mutation = useMutation(api.department.create, {
    onSuccess: () => {
      queryClient.invalidateQueries(api.department.queryKey);

      const message = locale.en.toastMessages.createSuccess.replace(
        "{{ 1 }}",
        "Department"
      );
      toast.success(message);

      resetForm();
      navigate!(routes.settings.routes!.department);
    },
  });

  /**
   * Not hook
   */
  const handleSubmit = () => {
    if (!navigate) return;
    if (!name) {
      return toast.error("Name is required!");
    }

    mutation.mutate({ name, description, isActive });
  };

  const resetForm = () => {
    setForm("name", "");
    setForm("description", "");
    setForm("isActive", true);
  };

  /**
   * Render
   */
  return (
    <Form
      department={{ name, description, isActive }}
      setForm={setForm}
      okText={locale.en.common.button.create}
      onOk={handleSubmit}
    />
  );
};
